module.exports = __webpack_public_path__ + "img/USA.960c0331.svg";